// App Version Management
export const APP_VERSION = '0.1.0';
export const BUILD_TIME = '2025-06-11T16:03:32.885Z';

// Generate a unique build hash based on timestamp
export const BUILD_HASH = 'mbs534ph';

// Check if app version has changed
export const checkForUpdates = (): boolean => {
  const storedVersion = localStorage.getItem('app_version');
  const currentVersion = `${APP_VERSION}-${BUILD_HASH}`;
  
  if (storedVersion !== currentVersion) {
    localStorage.setItem('app_version', currentVersion);
    return storedVersion !== null; // Return true if this is an update (not first visit)
  }
  
  return false;
};

// Force reload the app
export const forceReload = (): void => {
  // Clear all caches
  if ('caches' in window) {
    caches.keys().then(names => {
      names.forEach(name => {
        caches.delete(name);
      });
    });
  }
  
  // Clear localStorage cache indicators
  localStorage.removeItem('app_version');
  
  // Force reload
  window.location.reload();
};

// Get version info
export const getVersionInfo = () => ({
  version: APP_VERSION,
  buildTime: BUILD_TIME,
  buildHash: BUILD_HASH
});